// find the correct subitem based on the subroute
export const getAppRouteData = (app = {}, subRoute = '') => {
  if (!app.menu_items?.subitems) return undefined;
  
  // Try exact match first
  let match = app.menu_items.subitems.find((item) => item.route === subRoute);
  
  // If no exact match and app name is in the route, try matching the last segment
  if (!match && subRoute) {
    const appName = app.app_code_name;
    match = app.menu_items.subitems.find((item) => item.route === `/${appName}/${subRoute}`);
  }
  
  return match;
};

export const getAppPermissions = (app, subroute = '') => {
  // find the correct subitem based on the subroute
  const subrouteItem = getAppRouteData(app, subroute);
  return subrouteItem?.permissions;
};

export const isImpersonationBlocked = (app, subroute = '') => {
  // find the correct subitem based on the subroute
  const subrouteItem = getAppRouteData(app, subroute);
  return Boolean(subrouteItem?.block_impersonation);
};
